import { render, staticRenderFns } from "./CustomAttributeDropDownItem.vue?vue&type=template&id=3353cee5&scoped=true&"
import script from "./CustomAttributeDropDownItem.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDownItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDownItem.vue?vue&type=style&index=0&id=3353cee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3353cee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3353cee5')) {
      api.createRecord('3353cee5', component.options)
    } else {
      api.reload('3353cee5', component.options)
    }
    module.hot.accept("./CustomAttributeDropDownItem.vue?vue&type=template&id=3353cee5&scoped=true&", function () {
      api.rerender('3353cee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/customAttributes/CustomAttributeDropDownItem.vue"
export default component.exports